import Vue from 'vue'
import Router from 'vue-router'
import AdminIndex from '@/views/AdminIndex'
Vue.use(Router)

export default new Router({
  routes: [
    //登录
    {
      path: '/login',
      component: () =>
            import('@/views/login/index.vue'),
    },
    //工作台
    {
      path: '/staging',
      component: () =>
            import('@/views/staging/index.vue'),
    },
    //默认跳转合同列表
    {
      path: '/',
      redirect: '/admin/contract/mainContract/index'
    },
    {
      path: '/drive/index',
      // 对应组件的模板
      component: () =>
        import('@/views/workbench/drive.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/admin',
      name: 'AdminIndex',
      component: AdminIndex,
      children: [
        // 驾驶舱
        {
          path: 'drive/index',
          // 对应组件的模板
          component: () =>
            import('@/views/workbench/drive.vue'),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 合同汇总
        {
          path: 'contract/contractInquiry/index',
          // 对应组件的模板
          component: () =>
            import(
              '@/views/contractExecutionManagement/contractInquiry/Index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        //相关合同
        {
          path: 'contract/aboutContract/index/see/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/mainContract/aboutContract.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 主合同查看
        {
          path: 'contract/mainContract/index/see/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/mainContract/See.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 合同添加
        {
          path: 'contract/mainContract/index/add',
          component: () =>
            import(
              '@/views/contractExecutionManagement/mainContract/Create.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 合同编辑
        {
          path: 'contract/mainContract/index/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/mainContract/Create.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },

        // 合同列表
        {
          path: 'contract/mainContract/index',
          component: () =>
            import(
              '@/views/contractExecutionManagement/mainContract/Index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 合同三电迁改填报
        {
          path: 'contract/mainContract/electricRelocation/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/mainContract/listEntry/ElectricRelocation.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 合同清单
        {
          path: 'contract/mainContract/railwayAdministration/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/mainContract/listEntry/RailwayAdministration.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 合同章节点
        {
          path: 'contract/mainContract/demolition/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/mainContract/listEntry/Demolition.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 合同清单
        {
          path: 'contract/mainContract/other/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/mainContract/listEntry/Other.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 其他合同查看
        {
          path: 'contract/otheractInquiry/index/see/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/otherContracts/See.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },

        // 其他合同添加
        {
          path: 'contract/otheractInquiry/index/add',
          component: () =>
            import(
              '@/views/contractExecutionManagement/otherContracts/Create.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 其他合同编辑页面
        {
          path: 'contract/otheractInquiry/index/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/otherContracts/Create.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },

        // 其他合同列表
        {
          path: 'contract/otheractInquiry/index',
          component: () =>
            import(
              '@/views/contractExecutionManagement/otherContracts/Index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        //其他合同清单
        {
          path: 'contract/otheractInquiry/other/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/otherContracts/listEntry/Other.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        //合同查看
        {
          path: 'contract/contractPayment/index/see/:id',
          component: () =>
            import(
              '@/views/contractExecutionManagement/contractPayment/contractPaymentSummary/See.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        //合同列表
        {
          path: 'contract/contractPayment/index',
          component: () =>
            import(
              '@/views/contractExecutionManagement/contractPayment/contractPaymentSummary/Index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        //// 验工计价管理
        {
          path: 'pricing/summary/Index',
          component: () =>
            import(
              '@/views/pricingManagement/summary/Index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          // 季度征地拆迁
          path: 'pricing/quarter/Index/:id',
          name: 'PricingDemolition',
          component: () =>
            import(
              '@/views/pricingManagement/quarter/Index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 三电迁改
        {
          path: 'pricing/quarter/Relocation/:id',
          name: 'PricingRelocation',
          component: () =>
            import(
              '@/views/pricingManagement/quarter/Relocation'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'pricing/quarter/Management/:id',
          component: () =>
            import(
              '@/views/pricingManagement/quarter/Management.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'pricing/quarter/Railway/:id',
          component: () =>
            import(
              '@/views/pricingManagement/quarter/Railway.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        }, // 征地拆迁验工计价填报 树形图
        {
          path: 'pricing/quarter/tree/Valuation/:id',
          component: () =>
            import(
              '@/views/pricingManagement/tree/Valuation.vue'
            ),
          name: 'Valuation',
          meta: {
            keepAlive: false // 不需要缓存
          }
        }, // 三电迁改验工计价填报 树形图
        {
          path: 'pricing/quarter/tree/management/:id',
          component: () =>
            import(
              '@/views/pricingManagement/tree/InternalManagement.vue'
            ),
          name: 'InternalManagement',
          meta: {
            keepAlive: false // 不需要缓存
          }
        }, // 其他验工计价填报 树形图
        {
          path: 'pricing/quarter/tree/SanDianMoved',
          component: () =>
            import(
              '@/views/pricingManagement/tree/SanDianMoved.vue'
            ),
          name: 'SanDianMoved',
          meta: {
            keepAlive: false // 不需要缓存
          }
        }, // 八方确认库
        {
          path: 'pricing/confirm/Acquisition',
          component: () =>
            import(
              '@/views/pricingManagement/confirm/Acquisition.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'pricing/confirm/ThreeRelocation',
          component: () =>
            import(
              '@/views/pricingManagement/confirm/ThreeRelocation.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },

        {
          path: 'pricing/new/NewlyBuild/:id',
          component: () =>
            import(
              '@/views/pricingManagement/new/NewlyBuild.vue'
            ),
          name: 'PricingNewlyBuild',
          meta: {
            keepAlive: true // 需要缓存
          }
        },
        //
        {
          path: 'pricing/new/NewThree/:id',
          component: () =>
            import(
              '@/views/pricingManagement/new/NewThree.vue'
            ),
          name: 'PricingNewThree',
          meta: {
            keepAlive: true // 需要缓存
          }
        },
        //验工计价
        {
          path: 'pricing/new/NewManagement/:id',
          component: () =>
            import(
              '@/views/pricingManagement/new/NewManagement'
            ),
          name: 'PricingNewManagement',
          meta: {
            keepAlive: true // 需要缓存,
          }
        },
        // 验工计价
        {
          path: 'pricing/new/NewRailway/:id',
          component: () =>
            import(
              '@/views/pricingManagement/new/NewRailway'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        //查看征地拆迁
        {
          path: 'pricing/see/InspectLand/:id',
          component: () =>
            import(
              '@/views/pricingManagement/see/InspectLand.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        //验工计价
        {
          path: 'pricing/see/InspectionRailways/:id',
          component: () =>
            import(
              '@/views/pricingManagement/see/InspectionRailways.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        //验工计价
        {
          path: 'pricing/see/InspectRailway',
          component: () =>
            import(
              '@/views/pricingManagement/see/InspectRailway.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 验工计价编辑
        {
          path: 'pricing/edit/landPricingEdit/:id',
          component: () =>
            import(
              '@/views/pricingManagement/edit/landPricingEdit.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'pricing/edit/threePricingEdit/:id',
          component: () =>
            import(
              '@/views/pricingManagement/edit/threePricingEdit.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'pricing/edit/EditRailway/:id',
          component: () =>
            import(
              '@/views/pricingManagement/edit/EditRailway.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'pricing/edit/PricingEdit/:id',
          component: () =>
            import(
              '@/views/pricingManagement/edit/PricingEdit.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 数据权限
        {
          path: 'pricing/dataRights/Jurisdiction',
          component: () =>
            import(
              '@/views/pricingManagement/dataRights/Jurisdiction.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'pricing/dataRights/Business',
          component: () =>
            import(
              '@/views/pricingManagement/dataRights/Business.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 概算
        // 概算汇总  （以前的原批复）
        {
          path: 'budget/preliminaryDesign/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/preliminaryDesign/Index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 原批复
        {
          path: 'budget/originalApproval/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/originalApproval/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/budgetaryEstimate/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/budgetaryEstimate/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/constructionDrawingBudget/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/constructionDrawingBudget/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/constructionDrawingBudget/edit',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/constructionDrawingBudget/newEdit/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/reserveFund/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/reserveFund/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 风险包干费管理
        {
          path: 'budget/risk/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/risk/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/risk/see/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/risk/see/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/costReduction/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/costReduction/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/investmentAccount/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/investmentAccount/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/investmentSummary/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/investmentSummary/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          },
        },
        // 概算调整
        {
          path: 'budget/budgetEstimateAdjustment/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/budgetEstimateAdjustment/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          },
        },
        {
          path: 'budget/budgetEstimateAdjustment/edit/:id',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/budgetEstimateAdjustment/newEdit/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          },
        },
        {
          path: 'budget/budgetEstimateAdjustment/see/:id',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/budgetEstimateAdjustment/see/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          },
        },
        // 资金到位情况
        {
          path: 'budget/availabilityOfFunds/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/availabilityOfFunds/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          },
        },
        // 计划总投资
        {
          path: 'budget/availabilityOfFunds/planTotalInvest/see',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/availabilityOfFunds/planTotalInvest/see/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          },
        },
        {
          path: 'budget/availabilityOfFunds/planTotalInvest/edit',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/availabilityOfFunds/planTotalInvest/newEdit/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          },
        },
        // 资金到位
        {
          path: 'budget/availabilityOfFunds/fundsInPlace/see/:year',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/availabilityOfFunds/fundsInPlace/see/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          },
        },
        {
          path: 'budget/availabilityOfFunds/fundsInPlace/edit/:year',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/availabilityOfFunds/fundsInPlace/newEdit/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          },
        },
        // 统计分析
        {
          path: 'budget/statisticalAnalysis/index',
          component: () =>
            import(
              '@/views/planningStatistics/budgetManagement/statisticalAnalysis/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          },
        },

        // 投资计划管理
        {
          path: 'investment/annualSummary/index',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/annualSummary/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 查看@
        {
          path: 'investment/annualSummary/see/:id',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/annualSummary/see/see.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'investment/annualManagement/index',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/annualManagement/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 添加
        {
          path: 'investment/annualManagement/add',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/annualManagement/add/add.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },

        // 编辑
        {
          path: 'investment/annualManagement/:id',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/annualManagement/add/add.vue'
            ),

          meta: {
            keepAlive: false // 不需要缓存
          }
        },

        // 年度资金计划到位编制
        {
          path: 'investment/annualCapitalPreparation/index',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/annualCapitalPreparation/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'investment/annualCapitalPreparation/see',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/annualCapitalPreparation/see.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'investment/annualCapitalPreparation/edit',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/annualCapitalPreparation/edit.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },


        // 查看
        {
          path: 'investment/annualManagement/see/:id',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/annualManagement/see/see.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'investment/investmentSummary/index',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/investmentSummary/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 查看
        {
          path: 'investment/investmentSummary/see',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/investmentSummary/see/see.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'investment/investmentManagement/index',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/investmentManagement/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'investment/investmentManagement/add',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/investmentManagement/add/add.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'investment/investmentManagement/:id',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/investmentManagement/add/add.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'investment/investmentManagement/see/:id',
          component: () =>
            import(
              '@/views/planningStatistics/investmentPlan/investmentManagement/see/see.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 造价管理
        {
          path: 'costManagement/SettlementManagement',
          component: () =>
            import(
              '@/views/costManagement/SettlementManagement.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'costManagement/SettlementManagement/add',
          component: () =>
            import(
              '@/views/costManagement/NewSettlementManagement.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'costManagement/SettlementManagement/:id',
          component: () =>
            import(
              '@/views/costManagement/NewSettlementManagement.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'costManagement/SeeSettlementManagement/:id',
          component: () =>
            import(
              '@/views/costManagement/SeeSettlementManagement.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 资金计划管理
        {
          path: 'budget/annualPlan/index',
          component: () =>
            import(
              '@/views/planningStatistics/fundingPlan/annualPlan/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/annualPlan/see',
          component: () =>
            import(
              '@/views/planningStatistics/fundingPlan/annualPlan/See.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/monthlyBudget/index',
          component: () =>
            import(
              '@/views/planningStatistics/fundingPlan/monthlyBudget/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/monthlyBudget/see/:id',
          component: () =>
            import(
              '@/views/planningStatistics/fundingPlan/monthlyBudget/See.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/monthlySummary/add',
          component: () =>
            import(
              '@/views/planningStatistics/fundingPlan/monthlySummary/Create.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },

        {
          path: 'budget/monthlySummary/see',
          component: () =>
            import(
              '@/views/planningStatistics/fundingPlan/monthlySummary/See.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'budget/monthlySummary/index',
          component: () =>
            import(
              '@/views/planningStatistics/fundingPlan/monthlySummary/index.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 建设单位 异步加载代码
        {
          path: 'workbench/constructionUnit',
          component: () =>
            import(
              '@/views/workbench/constructionUnit/index.vue'
            ),
        },
        // 其他单位
        {
          path: 'workbench/otherUnits',
          component: () =>
            import('@/views/workbench/otherUnits/index.vue'),
        },
        // 工作台
        {
          path: 'workbench/workbenchs',
          component: () =>
            import('@/views/workbench/workbench/index.vue'),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'workbench/wait',
          component: () =>
            import('@/views/workbench/workbench/wait.vue'),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        // 消息通知
        {
          path: 'messageNotification/notification',
          component: () =>
            import(
              '@/views/messageNotification/notification.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
        {
          path: 'messageNotification/messageView',
          component: () =>
            import(
              '@/views/messageNotification/messageView.vue'
            ),
          meta: {
            keepAlive: false // 不需要缓存
          }
        },
      ]
    },
    //预算管理
    {
      path: '/plugInPage/see',
      component: () =>
        import('@/views/plugInPage/budgetManagement/see.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/plugInPage/edit',
      component: () =>
        import(
          '@/views/plugInPage/budgetManagement/edit.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    //进度管理
    {
      path: '/plugInPage/progressPayment/see',
      component: () =>
        import('@/views/plugInPage/progressPayment/see.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    //进度款管理编辑
    {
      path: '/plugInPage/progressPayment/edit',
      component: () =>
        import('@/views/plugInPage/progressPayment/edit.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    // 预付款
    {
      path: '/plugInPage/advanceCharge/see',
      component: () =>
        import('@/views/plugInPage/advanceCharge/see.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    {
      path: '/plugInPage/advanceCharge/edit',
      component: () =>
        import('@/views/plugInPage/advanceCharge/edit.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    // 竣工结算查看
    {
      path: '/plugInPage/completionSettlement/see',
      component: () =>
        import(
          '@/views/plugInPage/completionSettlement/see.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    // 竣工结算编辑
    {
      path: '/plugInPage/completionSettlement/edit',
      component: () =>
        import(
          '@/views/plugInPage/completionSettlement/edit.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    // 其他付款查看
    {
      path: '/plugInPage/otherPayments/see',
      component: () =>
        import('@/views/plugInPage/otherPayments/see.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    // 其他付款编辑
    {
      path: '/plugInPage/otherPayments/edit',
      component: () =>
        import('@/views/plugInPage/otherPayments/edit.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    // 变更管理
    {
      path: '/plugInPage/changeManagement/see',
      component: () =>
        import('@/views/plugInPage/changeManagement/see.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
    // 变更管理编辑
    {
      path: '/plugInPage/changeManagement/edit',
      component: () =>
        import(
          '@/views/plugInPage/changeManagement/edit.vue'),
      meta: {
        keepAlive: false // 不需要缓存
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js